import { useCallback, useEffect, useState } from "react";
import { _Cities, _StatesCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { PrintJson } from "../../../theme/Component/PrintJson";

interface Props {
    state: any
}
export const CitiView = ({ state }: Props) => {

    const _state = useDataBean(_Cities);
    const { bean, setBean, lista, setLista, instance } = _state;
    const [child, setChild] = useState<number>(0);



    const getStates = useCallback(() => {
        if (!state.IDStates) return;
        instance.getCitiesCatalog(state.IDCountries, state.IDStates, null, 1, 100).then(
            (resp: any) => {
                const sortedList = (resp.List || []).sort((a: any, b: any) =>
                    (a.DataBeanProperties.Name || "").localeCompare(b.DataBeanProperties.Name || "")
                );
                setLista(sortedList);
            }
        )
    }, [state, instance, setLista])

    useEffect(() => {
        getStates();
    }, [getStates]);

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="col-md-12">
                    <ul className="list-group">
                        {lista.length > 0 &&
                            lista.map((item: any, index: number) => {
                                return (
                                    <li key={index} className="list-group-item itemh" onClick={() => { setBean(item.DataBeanProperties) }}>

                                        <strong className={child === item.DataBeanProperties.IDCities ? 'cursor treeselect' : 'cursor'} onClick={() => {
                                            localStorage.setItem('SiteID', JSON.stringify(item.DataBeanProperties));
                                            setChild(item.DataBeanProperties.IDCities);

                                        }}>
                                            <strong style={{ marginLeft: '15px' }}>{item.DataBeanProperties.IDCities} </strong>
                                            <small>{item.DataBeanProperties.Name}</small>
                                        </strong>

                                    </li>
                                );
                            })}
                    </ul>
                </div>
                {/* <PrintJson json={lista} /> */}
            </div>
        </div>
    )
}